import { Box, Button, DatePicker, FormField, Grid, Modal, SpaceBetween, TimeInput, } from "@cloudscape-design/components-themed/components";
import React, { useEffect, useState } from "react";
import ConfirmationModal from "./confirmation";
import { GetISODateString, validateDateTime } from "@/presentation/pages";
import { PATH_DOCUMENTATION } from "@/presentation/common-utils/constants";
import { getUrlParamsName } from "@/presentation/common-utils/common-utils";
import ExternalLink from "@/presentation/components/links/external-link";
const RotateCredentials = (props) => {
    var _a;
    const headerText = "Rotate Credentials";
    const [isRotateLoading, setIsRotateLoading] = useState((props === null || props === void 0 ? void 0 : props.isRotateLoading) || false);
    const [showRotateModal, setShowRotateModal] = useState(false);
    const onRotateInit = () => setShowRotateModal(true);
    const onRotateDiscard = () => setShowRotateModal(false);
    const [timeValue, setTimeValue] = useState("");
    const [dateValue, setDateValue] = useState("");
    const [dateValueError, setDateValueError] = useState(false);
    const [dateErrorText, setDateErrorText] = useState("");
    const defaultTimeValue = "23:59:59";
    const referrer = getUrlParamsName('referrer');
    const rotateReferrer = referrer || window.location.pathname;
    const rotatePath = `${PATH_DOCUMENTATION.ROTATE_PROXY_CREDENTIALS}?referrer=${rotateReferrer}`;
    const updateValidation = (date, time) => {
        const result = validateDateTime(date, time);
        setDateValueError(result.error);
        setDateErrorText(result.message);
    };
    const dateRangeOnChange = (detail) => {
        setDateValue(detail.value);
        const currTimeValue = timeValue === "" ? defaultTimeValue : timeValue;
        setTimeValue(currTimeValue); // Set default time to end of day 23:59:00
        updateValidation(detail.value, currTimeValue);
    };
    const handleTimeChange = (detail) => {
        setTimeValue(detail.value);
        if (dateValue && dateValue !== "") {
            updateValidation(dateValue, detail.value);
        }
        else {
            setDateValueError(false);
            setDateErrorText("");
        }
    };
    useEffect(() => {
        setIsRotateLoading((props === null || props === void 0 ? void 0 : props.isRotateLoading) || false);
    }, [props === null || props === void 0 ? void 0 : props.isRotateLoading]);
    const resetLocalState = () => {
        setShowRotateModal(false);
        setTimeValue("");
        setDateValue("");
        setDateErrorText("");
        setDateValueError(false);
    };
    const closeModal = () => {
        resetLocalState();
        props.onDiscard();
    };
    const onRotateConfirm = () => {
        const isoString = GetISODateString(dateValue, timeValue);
        resetLocalState();
        props.onRotate(isoString);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Modal, { visible: props.visible, onDismiss: closeModal, header: ((_a = props.rotateModalStrings) === null || _a === void 0 ? void 0 : _a.headerModalText) || headerText, closeAriaLabel: "Close dialog", footer: React.createElement(Box, { float: "right" },
                React.createElement(SpaceBetween, { direction: "horizontal", size: "xs" },
                    React.createElement(Button, { variant: "link", onClick: closeModal }, "Cancel"),
                    React.createElement(Button, { disabled: timeValue === "" || dateValue === "" || dateValueError, onClick: onRotateInit, variant: timeValue === "" || dateValue === "" || isRotateLoading || dateValueError
                            ? "normal"
                            : "primary", loading: isRotateLoading }, "Continue"))) },
            React.createElement(Box, { margin: { bottom: "l" } },
                React.createElement(FormField, { label: "Expiry Date and Time", description: React.createElement("div", { style: { display: 'flex', alignItems: 'center' } },
                        "Set expiry for the current credentials. New credentials will be generated upon save.",
                        React.createElement("span", { style: { marginRight: '2.5px' } }),
                        React.createElement("div", { className: 'kivera-external-link-xs' },
                            React.createElement(ExternalLink, { to: rotatePath, label: "Learn more" }))), constraintText: 'Time is in 24 hour format.', errorText: dateValueError ? dateErrorText : "" },
                    React.createElement(Grid, { gridDefinition: [{ colspan: 5 }, { colspan: 4 }] },
                        React.createElement(DatePicker, { onChange: ({ detail }) => {
                                dateRangeOnChange(detail);
                            }, invalid: dateValueError, value: dateValue, placeholder: "Select expiry date" }),
                        React.createElement("div", { style: { marginLeft: "-12px" } },
                            React.createElement(TimeInput, { "data-input": "expiry-time-input", format: "hh:mm:ss", invalid: dateValueError, value: timeValue, placeholder: "hh:mm:ss", onChange: ({ detail }) => handleTimeChange(detail), onBlur: () => {
                                    if (dateValue !== "" && timeValue === "") {
                                        setTimeValue(defaultTimeValue);
                                    }
                                } })))))),
        React.createElement(ConfirmationModal, { visible: showRotateModal, onDiscard: onRotateDiscard, onRotate: onRotateConfirm, rotateModalStrings: props.rotateModalStrings, confirmationBody: props.confirmationBody })));
};
export default RotateCredentials;
